// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__L5Fwx","detailsBorder":"styles_detailsBorder__Qcci4"};